import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { findKeyFromArrayByValue, returnSign } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ 'id': 1, 'name': t('success') },
		{ 'id': -1, 'name': t('delete') },
	]

	const counterparties = [
		{ 'id': "clients", 'name': t('clients') },
		{ 'id': "suppliers", 'name': t('suppliers') },
		{ 'id': "employee", 'name': t('employees') },
	]

	const [data, setData] = useState([])
	const [accounts, setAccounts] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'transaction_type': 'minus' })
	const [filterData, setFilterData] = useState({ 'status': 1 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/payment-purposes', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-purposes', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
			setSelectedItem({})
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/payment-purposes"
		var urlParams = ""

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
		}

		setDropdownIsOpen(false)
	}

	function toggleModal(bool = false, item = { 'transaction_type': 'minus' }) {
		setShowModal(bool)
		setSelectedItem(item)

		if (bool) {
			if (!accounts.length) getAccounts()
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	function returnEntityType(item) {
		var name = t('no')
		if (item?.counterparty === 'suppliers') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'agent') {
			name = t('agent')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'clients') {
			name = t('client')
		}

		return name
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('income_expense')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					<div className="filter-block">
						<div className="filter">
							<strong>{t('filter')}</strong>
							<br />
							{filterData.search &&
								<span className="me-2">
									<b>{t('search')}: </b>
									<span>{filterData.search}</span>
								</span>
							}
							{filterData.status &&
								<span className="me-2">
									<b>{t('status')}: </b>
									{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
								</span>
							}
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('operation_account')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('counterparty')}</th>
									<th style={{ 'width': '30%' }}>Telegram Chat ID</th>
									<th style={{ 'width': '10%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={item.name}>{item.name}</td>
										<td className="td-ellipsis" title={item.account_name}>{item.account_name}</td>
										<td>
											{item.transaction_type === 'minus' &&
												<span>{t('expense')}</span>
											}
											{item.transaction_type === 'plus' &&
												<span>{t('income')}</span>
											}
										</td>
										<td>{returnEntityType(item)}</td>
										<td>
											{item.telegram_chat_id
												? <span className="text-success"><i className="uil uil-telegram me-1"></i>{item.telegram_chat_id}</span>
												: <span className="text-muted">—</span>
											}
										</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name" value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('type')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'minus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}>
											{t('expense')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'plus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}>
											{t('income')}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('operation_account')}</label>
							<Select
								isClearable
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'account_id': option?.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('report_account')}</label>
							<Select
								isClearable
								options={counterparties}
								value={counterparties.find(option => option.id === selectedItem.counterparty)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'counterparty': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>Telegram Chat ID</label>
							<input type="text" className="form-control" name="telegram_chat_id"
								value={selectedItem.telegram_chat_id ?? ''}
								placeholder="Masalan: 1058156341"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'telegram_chat_id': e.target.value || null })} />
							<small className="text-muted">Chiqim qayd etilganda shu chat IDga bildirishnoma yuboriladi</small>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

		</>
	)
}

export default Index